import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@blueprintjs/core';
import { SectionTab } from 'polotno/side-panel';

export const SizePanel = observer(({ store }) => {
  const adjust = () => {
    store.pages.forEach((page) => {
      const logo = page.children.find((child) => child.name === 'logo');
      if (logo) {
        logo.set({
          x: store.width / 2 - logo.width / 2,
        });
      }
      const phone = page.children.find((child) => child.name === 'phone');
      if (phone) {
        phone.set({
          x: store.width - phone.width - 50,
        });
      }
    });
  };
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Button
        fill
        onClick={() => {
          store.setSize(1920, 1080, false);
          adjust();
        }}
      >
        1920x1080px
      </Button>
      <Button
        fill
        onClick={() => {
          store.setSize(1080, 1080, false);
          adjust();
        }}
        style={{ marginTop: '20px' }}
      >
        1080x1080px
      </Button>
    </div>
  );
});

export const SizeSection = {
  name: 'size',
  Tab: (props) => (
    <SectionTab name="Artboard Size" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/artboard-size.svg'}
        alt="Size"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: SizePanel,
};
